import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute, useRouter } from '@/router'
import { UserModule } from '@/store/modules/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  title: {
    type: String,
    required: true,
  },
  logo: {
    default: require('@/assets/logo.png')
  },
  companyName: {
    type: String,
    required: true,
  }
},
  setup(__props) {

const logoSrc = require('@/assets/logo-北师大.svg')
const smallLogoSrc = require('@/assets/logotype-北师大.svg')


const route = useRoute()
const router = useRouter()
function handleExit() {
  UserModule.LogOut()
}
const routes = computed(() => {
  const currentRoute = router.currentRoute
  return router.options.routes?.filter(i => {
    return !i.meta?.hidden && currentRoute.meta?.navSortIndex === i.meta?.navSortIndex
  })
})
const activeMenuName = computed(() => {
  const { meta } = route.value
  if (meta?.title) {
    return meta.title
  }
  return ''
})
// // 切换一级菜单、路由跳转
// const handleSelect = (index: string) => {
//   console.log('index: ', index);
//   // router.push(index)
//   (document.activeElement as any)?.blur()
// }

// const activeMenu = computed(() => {
//   const { meta, path } = route.value
//   if (meta?.activeMenu) {
//     return meta.activeMenu
//   }
//   return path
// })
function handleBackHome() {
  router.push('/')
}
// const options = [
//   {
//     label: '账户信息',
//     command: 'account'
//   },
//   {
//     label: '使用帮助',
//     command: 'manual'
//   }
// ]
// function handleCommand(command: string) {
//   if (command === 'account') {
//     const currentRoute = router.currentRoute
//     if (currentRoute.name !== 'account') {
//       router.push('/account')
//     }
//   } else if (command === 'manual') {
//     // TODO 后续替换用户手册文件
//     let fileName = '使用手册.pdf'
//     window.open(`/static/pdf/${fileName}`, '_blank')
//   }
// }

return { __sfc: true,logoSrc, smallLogoSrc, route, router, handleExit, routes, activeMenuName, handleBackHome }
}

})